
<section class="disponibilidade-page">

  <!-- CABEÇALHO -->
  <header class="topbar">
    <div>
      <span class="topbar-label">
        Gerenciamento
      </span>

      <h1>Disponibilidade de reservas</h1>

      <p>
        Controle os meses disponíveis para novas reservas
        em cada acomodação.
      </p>
    </div>
  </header>

  <!-- FILTROS -->
  <section class="disponibilidade-filtros">

    <div class="campo-filtro">
      <label for="acomodacao">Acomodação</label>

      <select
        id="acomodacao"
        [(ngModel)]="quartoId"
        (ngModelChange)="alterarAcomodacao()"
        [disabled]="carregando"
      >
        <option
          *ngFor="let acomodacao of acomodacoes"
          [ngValue]="acomodacao.id"
        >
          {{ acomodacao.nome }}
        </option>
      </select>
    </div>

    <div class="campo-filtro campo-ano">
      <label for="ano">Ano de referência</label>

      <select
        id="ano"
        [(ngModel)]="ano"
        (ngModelChange)="alterarAno()"
        [disabled]="carregando"
      >
        <option
          *ngFor="let opcaoAno of anos"
          [ngValue]="opcaoAno"
        >
          {{ opcaoAno }}
        </option>
      </select>
    </div>

    <button
      type="button"
      class="btn-atualizar"
      (click)="carregarDisponibilidade()"
      [disabled]="carregando"
    >
      <span
        class="material-symbols-outlined"
        [class.rotacionando]="carregando"
      >
        refresh
      </span>

      {{ carregando ? 'Carregando...' : 'Atualizar' }}
    </button>

  </section>

  <!-- RESUMO -->
  <section
    class="disponibilidade-resumo"
    [attr.aria-busy]="carregando"
  >

    <article class="resumo-card">
      <div class="resumo-conteudo">
        <span class="resumo-label">
          MESES LIBERADOS
        </span>

        <strong class="resumo-numero">
          {{ totalLiberados }}
        </strong>

        <span class="resumo-descricao">
          Meses disponíveis para novas reservas
        </span>
      </div>

      <span class="resumo-indicador liberado">
        <span class="material-symbols-outlined">
          check_circle
        </span>
      </span>
    </article>

    <article class="resumo-card">
      <div class="resumo-conteudo">
        <span class="resumo-label">
          MESES BLOQUEADOS
        </span>

        <strong class="resumo-numero">
          {{ totalBloqueados }}
        </strong>

        <span class="resumo-descricao">
          Meses indisponíveis para novas reservas
        </span>
      </div>

      <span class="resumo-indicador bloqueado">
        <span class="material-symbols-outlined">
          event_busy
        </span>
      </span>
    </article>

  </section>

  <!-- CALENDÁRIO -->
  <section class="disponibilidade-section">

    <div class="disponibilidade-cabecalho">
      <div>
        <span class="section-label">
          CONTROLE DE DISPONIBILIDADE
        </span>

        <h2>
          Calendário de {{ ano }}
        </h2>

        <p>
          Clique em um mês para liberar ou bloquear
          novas reservas.
        </p>
      </div>

      <div class="legenda">
        <span>
          <i class="legenda-ponto ponto-liberado"></i>
          Liberado
        </span>

        <span>
          <i class="legenda-ponto ponto-bloqueado"></i>
          Bloqueado
        </span>
      </div>
    </div>

    <!-- CARREGAMENTO -->
    <div
      class="loading"
      *ngIf="carregando"
      role="status"
      aria-live="polite"
    >
      <span class="spinner"></span>
      Carregando disponibilidade...
    </div>

    <!-- MESES -->
    <div
      class="meses-grid"
      *ngIf="!carregando"
    >

      <button
        type="button"
        class="mes-card"
        *ngFor="let mes of meses"
        [class.mes-liberado]="mes.liberado"
        [class.mes-bloqueado]="!mes.liberado"
        [class.mes-salvando]="mes.salvando"
        [disabled]="mes.salvando || carregando"
        [attr.aria-pressed]="mes.liberado"
        [attr.aria-label]="
          (mes.liberado ? 'Bloquear ' : 'Liberar ')
          + mes.nome + ' de ' + ano
        "
        (click)="alternarMes(mes)"
      >

        <div class="mes-cabecalho">

          <span class="mes-numero">
            {{ mes.mes.toString().padStart(2, '0') }}
          </span>

          <span
            class="material-symbols-outlined mes-icone"
            [class.rotacionando]="mes.salvando"
          >
            {{
              mes.salvando
                ? 'sync'
                : mes.liberado
                  ? 'check_circle'
                  : 'lock'
            }}
          </span>

        </div>

        <div class="mes-informacoes">

          <h3>{{ mes.nome }}</h3>

          <span
            class="mes-status"
            [class.status-liberado]="mes.liberado"
            [class.status-bloqueado]="!mes.liberado"
          >
            <ng-container *ngIf="mes.salvando">
              Salvando...
            </ng-container>

            <ng-container
              *ngIf="!mes.salvando && mes.liberado"
            >
              Liberado
            </ng-container>

            <ng-container
              *ngIf="!mes.salvando && !mes.liberado"
            >
              Bloqueado
            </ng-container>
          </span>

        </div>

        <div class="mes-rodape">
          <span>
            {{
              mes.liberado
                ? 'Bloquear mês'
                : 'Liberar mês'
            }}
          </span>

          <span class="mes-seta">→</span>
        </div>

      </button>

    </div>

    <!-- OBSERVAÇÃO -->
    <div class="disponibilidade-aviso">
      <span class="material-symbols-outlined">
        info
      </span>

      <p>
        A liberação de um mês permite novas reservas apenas
        nas datas que não possuem reservas existentes ou
        bloqueios de calendário. Meses não liberados
        permanecem indisponíveis.
      </p>
    </div>

  </section>

</section>
